"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonNew = exports.ButtonNewVariant = void 0;
const tailwind_merge_1 = require("tailwind-merge");
var ButtonNewVariant;
(function (ButtonNewVariant) {
    ButtonNewVariant["Primary"] = "primary";
    ButtonNewVariant["PrimaryNoHover"] = "primaryNoHover";
    ButtonNewVariant["Error"] = "error";
})(ButtonNewVariant || (exports.ButtonNewVariant = ButtonNewVariant = {}));
const variants = {
    [ButtonNewVariant.Primary]: 'bg-primary border-secondary hover:border-primary hover:bg-secondary',
    [ButtonNewVariant.PrimaryNoHover]: 'bg-primary border-secondary',
    [ButtonNewVariant.Error]: 'bg-pink border-none hover:bg-pink',
};
function ButtonNew(_a) {
    var { children, className, disabled, variant = ButtonNewVariant.Primary } = _a, props = __rest(_a, ["children", "className", "disabled", "variant"]);
    const variantClasses = variants[variant];
    return (<button disabled={disabled} type="submit" className={(0, tailwind_merge_1.twMerge)('group bg-primary relative rounded-lg px-5 py-1.5 text-md shadow motion-safe:hover:scale-[102%] motion-safe:active:scale-[98%] tracking-wide border-[3px] border-secondary motion-safe:duration-300 font-medium', disabled && 'opacity-50 cursor-not-allowed motion-safe:hover:scale-100 motion-safe:active:scale-100', variantClasses, className)} {...props}>
			{children}
		</button>);
}
exports.ButtonNew = ButtonNew;
